function IsLogin(require_login) {///是否需要登录查看
    if(!require_login){
        return true
    }else {
        let userInfo=window.localStorage.getItem('userInfo');
        return Boolean(userInfo)
    }

}
export default IsLogin